var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 0.85H4.97816C2.70206 0.85 0.85 2.70155 0.85 4.97816V8.10891V14.2078V26.0995C0.85 28.3761 2.70204 30.2281 4.97816 30.2281H40.8284C43.105 30.2281 44.957 28.3761 44.957 26.0995V14.2078V8.10891V4.97816C44.957 2.70154 43.1049 0.85 40.8284 0.85ZM4.97816 2.12349H40.8284C42.4024 2.12349 43.6835 3.40463 43.6835 4.97816V7.47216H2.12349V4.97816C2.12349 3.40414 3.4046 2.12349 4.97816 2.12349ZM43.6835 13.5711H2.12349V8.74565H43.6835V13.5711ZM40.8284 28.9546H4.97816C3.40461 28.9546 2.12349 27.674 2.12349 26.0995V14.8446H43.6835V26.0995C43.6835 27.674 42.4024 28.9546 40.8284 28.9546Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6792 19.95H6.32083C6.20948 19.95 6.11557 20.0202 6.05193 20.1193C5.98795 20.2189 5.95 20.3536 5.95 20.5C5.95 20.6464 5.98795 20.7811 6.05193 20.8807C6.11557 20.9798 6.20948 21.05 6.32083 21.05H18.6792C18.7907 21.05 18.8846 20.9798 18.9482 20.8807C19.0121 20.781 19.05 20.6463 19.05 20.5C19.05 20.3537 19.0121 20.219 18.9482 20.1193C18.8846 20.0202 18.7907 19.95 18.6792 19.95Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6338 19.95H21.4867C21.19 19.95 20.95 20.19 20.95 20.4867C20.95 20.7835 21.19 21.0235 21.4867 21.0235H23.5603H25.6338C25.9306 21.0235 26.1706 20.7835 26.1706 20.4867C26.1706 20.19 25.9306 19.95 25.6338 19.95Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3346 22.95H19.6654C19.4717 22.95 19.2945 23.0088 19.1647 23.1063C19.0348 23.2039 18.95 23.3426 18.95 23.5C18.95 23.6574 19.0348 23.7961 19.1647 23.8937C19.2945 23.9912 19.4717 24.05 19.6654 24.05H22.5H25.3346C25.5283 24.05 25.7055 23.9912 25.8353 23.8937C25.9652 23.7961 26.05 23.6574 26.05 23.5C26.05 23.3426 25.9652 23.2039 25.8353 23.1063C25.7055 23.0088 25.5283 22.95 25.3346 22.95Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5247 22.95H12.4753C12.1825 22.95 11.95 23.1983 11.95 23.5C11.95 23.8017 12.1825 24.05 12.4753 24.05H14.5H16.5247C16.8175 24.05 17.05 23.8017 17.05 23.5C17.05 23.1983 16.8175 22.95 16.5247 22.95Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61977 22.95H6.38023C6.25617 22.95 6.14749 23.0161 6.07146 23.116C5.99548 23.216 5.95 23.3518 5.95 23.5C5.95 23.6482 5.99548 23.784 6.07146 23.884C6.14749 23.9839 6.25617 24.05 6.38023 24.05H8H9.61977C9.74383 24.05 9.85251 23.9839 9.92854 23.884C10.0045 23.784 10.05 23.6482 10.05 23.5C10.05 23.3518 10.0045 23.216 9.92854 23.116C9.85251 23.0161 9.74383 22.95 9.61977 22.95Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.35H35C34.0887 20.35 33.35 21.0887 33.35 22C33.35 22.9113 34.0887 23.65 35 23.65H39C39.9113 23.65 40.65 22.9113 40.65 22C40.65 21.0887 39.9113 20.35 39 20.35Z",
    stroke: "#222222",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.d9c340c1411b82ece72d3eb6cb24e220.svg";
export { ForwardRef as ReactComponent };